export default "__VITE_ASSET__45a994ed__"